var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 21,
    viewBox: "0 0 10 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7859 10.5L8.6784 16.3925L7.50007 17.5709L1.0184 11.0892C0.862177 10.9329 0.774414 10.721 0.774414 10.5C0.774414 10.2791 0.862177 10.0671 1.0184 9.91087L7.50007 3.4292L8.6784 4.60753L2.7859 10.5Z",
    fill: "#092538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleBackIcon);
export default __webpack_public_path__ + "static/media/simpleBackIcon.9c569d7d4f0b5d948408b8839f7017ca.svg";
export { ForwardRef as ReactComponent };